/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thankyou_TitleInputs */

const en_thankyou_title = /** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmission Received.`)
};

const es_thankyou_title = /** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmisión Recibida.`)
};

const fr_thankyou_title = /** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmission Reçue.`)
};

const de_thankyou_title = /** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übertragung erhalten.`)
};

const id_thankyou_title = /** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmisi Diterima.`)
};

/** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */
const ja_thankyou_title = en_thankyou_title;

/** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */
const zh_thankyou_title = en_thankyou_title;

/** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */
const ar_thankyou_title = en_thankyou_title;

/** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */
const it_thankyou_title = en_thankyou_title;

/** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */
const ru_thankyou_title = en_thankyou_title;

/** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */
const pt_thankyou_title = en_thankyou_title;

/** @type {(inputs: Thankyou_TitleInputs) => LocalizedString} */
const ko_thankyou_title = en_thankyou_title;

/**
* | output |
* | --- |
* | "Transmission Received." |
*
* @param {Thankyou_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const thankyou_title = /** @type {((inputs?: Thankyou_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thankyou_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thankyou_title(inputs)
	if (locale === "es") return es_thankyou_title(inputs)
	if (locale === "fr") return fr_thankyou_title(inputs)
	if (locale === "de") return de_thankyou_title(inputs)
	if (locale === "ja") return ja_thankyou_title(inputs)
	if (locale === "zh") return zh_thankyou_title(inputs)
	if (locale === "ar") return ar_thankyou_title(inputs)
	if (locale === "id") return id_thankyou_title(inputs)
	if (locale === "it") return it_thankyou_title(inputs)
	if (locale === "ru") return ru_thankyou_title(inputs)
	if (locale === "pt") return pt_thankyou_title(inputs)
	return ko_thankyou_title(inputs)
});